var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-container"},[_c('PlainNavbar',[_c('img',{staticStyle:{"height":"40px","margin":"4px 0 0"},attrs:{"slot":"logo","src":require("@/assets/brand/v-remind-logo-text.png"),"alt":"VRemind Logo"},slot:"logo"})]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }